import React, { useState, useCallback } from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useSelector, useDispatch } from "react-redux";
import { setUserType, USER_TYPES } from "../../../store/globalSlice";

const MaterialUISwitch = styled(Switch)(({ _theme, userTypes }) => ({
  width: 290,
  height: 45,
  padding: 0,
  fontSize: 14,
  textTransform: "uppercase",
  "& .MuiSwitch-switchBase": {
    margin: 5,
    padding: 0,
    transform: "translateX(1px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(110px)",
      "& .MuiSwitch-thumb:before": {
        content: `"${userTypes[0]}"`,
        left: 40,
        top: 10,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#F1F1F1",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#C60C30",
    width: 120,
    height: 35,
    borderRadius: 5,
    "&:before": {
      content: `"${userTypes[1]}"`,
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 10,
      left: 25,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#F1F1F1",
    borderRadius: 5,
    width: 240,
    "&:before, &:after": {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      fontWeight: "bold",
    },
    "&:before": {
      color: "#C60C30",
      content: `"${userTypes[1]}"`,
      left: 31,
    },
    "&:after": {
      color: "#C60C30",
      content: `"${userTypes[0]}"`,
      right: 48,
    },
  },
}));

export default function Toggle() {
  const dispatch = useDispatch();
  const type = useSelector((store) => store.global.user.type);
  const [checked, setChecked] = useState(type === USER_TYPES[0]);

  const handleChange = useCallback(
    ({ target }) => {
      dispatch(setUserType(USER_TYPES[target?.checked ? 0 : 1]));
      setChecked(target?.checked);
    },
    [dispatch]
  );

  return (
    <FormGroup sx={{ display: "block" }}>
      <FormControlLabel
        sx={{ width: 240 }}
        control={
          <MaterialUISwitch
            sx={{ ml: 1.5, width: 240 }}
            checked={checked}
            onChange={handleChange}
            inputProps={{ "aria-label": "controlled" }}
            userTypes={USER_TYPES}
          />
        }
      />
    </FormGroup>
  );
}
